import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@sm/wds-react';

export const Block = ({ children }) => {
  return (
    <Container
      mt="5"
      mb="5"
      ml="4"
      mr="4"
      key="CustomerSatisfaction"
      className="sm-nav-submenu__by-need-container"
    >
      {children}
    </Container>
  );
};

export default Block;

Block.propTypes = {
  children: PropTypes.node.isRequired,
};
